import { getStates } from '@store/mocks';
import { useMemo } from 'react';

export const useGetStates = () => {
  const states = useMemo(() => getStates(), []);
  return { states };
};
